import React from 'react';
import PropTypes from 'prop-types';
import ActionColumn from 'screens/common/components/ActionColumn';

const TableResponsiveCard = ({
  page,
  cardTittles,
  setIsModalOpen,
  setSelectedRowData,
  handleAction,
  renderCollapsibleContent,
  prepareRow,
  expandedRow
}) => {
  return (
    <div className="card-container d-block d-md-none ">
      {page.map((row, i) => {
        prepareRow(row);
        const hasMoreData =
          row.original.more && Object.keys(row.original.more).length > 0;
        const isExpanded = expandedRow === i;

        // Extract user information
        const userName = row.original[cardTittles[0]] || 'Unknown User';
        const userInitials = userName
          .split(' ')
          .map(n => n[0])
          .join('')
          .slice(0, 2)
          .toUpperCase();

        return (
          <div className="card mb-3 shadow-md border" key={i}>
            <div
              className="p-2 d-flex align-items-center"
              onClick={() => {
                setSelectedRowData(row);
                setIsModalOpen(true);
              }}
            >
              {/* Circle with initials */}
              <div className="flex-shrink-0 ms-1">
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: '50px',
                    height: '50px',
                    fontSize: '18px',
                    fontWeight: 'bold'
                  }}
                >
                  {userInitials}
                </div>
              </div>

              {/* User details */}
              <div className="ms-3 flex-grow-1 w-100">
                {/* First row: ID (userName) + Action button */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <p className="mb-0 bold mt-2 small">{userName}</p>
                  {row.original.action && (
                    <div onClick={e => e.stopPropagation()}>
                      <ActionColumn
                        key={i}
                        row={row}
                        handleAction={handleAction}
                        traceability={true}
                      />
                    </div>
                  )}
                </div>
                <div className="d-flex flex-wrap">
                  <div className="w-50">
                    {cardTittles.slice(1).map((cardTittle, cardIndex) => {
                      let cell = row.cells.find(
                        cell => cell.column.Header === cardTittle
                      );
                      if (
                        !cell ||
                        cell.column.Header === 'S No' ||
                        cell.column.Header === 'Action' ||
                        cardIndex % 2 !== 0
                      )
                        return null;

                      return (
                        <p key={cardIndex} className="mb-0 text-muted small">
                          {Array.isArray(cell.value) ? (
                            cell.value.join(', ')
                          ) : typeof cell.value === 'object' &&
                            cell.column.Header === 'Severity' ? (
                            <span style={{ color: cell.value.color }}>
                              {cell.value.label}
                            </span>
                          ) : (
                            cell.render('Cell')
                          )}
                        </p>
                      );
                    })}
                  </div>
                  <div className="w-50 text-end">
                    {cardTittles.slice(1).map((cardTittle, cardIndex) => {
                      let cell = row.cells.find(
                        cell => cell.column.Header === cardTittle
                      );
                      if (
                        !cell ||
                        cell.column.Header === 'S No' ||
                        cell.column.Header === 'Action' ||
                        cardIndex % 2 === 0
                      )
                        return null;

                      return (
                        <p key={cardIndex} className="mb-0 text-muted small">
                          {Array.isArray(cell.value) ? (
                            cell.value.join(', ')
                          ) : typeof cell.value === 'object' &&
                            cell.column.Header === 'Severity' ? (
                            <span style={{ color: cell.value.color }}>
                              {cell.value.label}
                            </span>
                          ) : (
                            cell.render('Cell')
                          )}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Expandable content */}
            {hasMoreData && (
              <div className="card-footer">
                <div
                  className={`expand-content ${
                    isExpanded ? 'show' : ''
                  } text-muted`}
                >
                  {renderCollapsibleContent(row.original.more)}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
TableResponsiveCard.propTypes = {
  page: PropTypes.array.isRequired,
  cardTittles: PropTypes.arrayOf(PropTypes.string),
  setIsModalOpen: PropTypes.func.isRequired, // 'setIsModalOpen' should be a function (useState function)
  setSelectedRowData: PropTypes.func.isRequired, // 'setSelectedRowData' should be a function (useState function)
  handleAction: PropTypes.func.isRequired,
  prepareRow: PropTypes.func,
  renderCollapsibleContent: PropTypes.func,
  expandedRow: PropTypes.number
};
export default TableResponsiveCard;
